import { toLower } from 'lodash';
export const endpointConversation = '/conversation';
export const endpointMessage = '/message';
/**
 * Endpoint generator function for the messages associated to a conversation.
 */
export const getEndpointConversationMessage = (conversationId) => `${endpointConversation}/${toLower(conversationId)}/messages`;
/**
 * Endpoint generator function for a specific message.
 */
export const getEndpointMessage = (messageId) => `${endpointMessage}/${toLower(messageId)}`;
